import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import ImporterImage from '../../../../UI/ImporterImage/ImporterImage';
import Bouton from '../../../../UI/Bouton/Bouton';
import AttenteRequete from '../../../../../hoc/AttenteRequete/AttenteRequete';
import { checkMot } from '../../../../../ressources/functionJS/checkMot';
import * as glossaire_pattern from '../../../../../ressources/glossaires/glossaire_pattern';
import * as glossaire_type_de_couche from '../../../../../ressources/glossaires/glossaire_type_de_couche';
import { IsArrayString } from '../../../../../ressources/functionJS/IsArrayString';
import * as requestType from '../../../../../ressources/glossaires/glossaire_requetes';
import * as actions from '../../../../../services/actions';
import * as s from '../../../../../ressources/StyleGlobal/StyleGlobal';
import styles from '../../FormulaireVue/FormulaireVue.module.scss';

const AjouterCouche = ({ view_id, preconfigurerVue, affichageProfil }) => {
  const dispatch = useDispatch();
  const [layerType, setLayerType] = useState(glossaire_type_de_couche.Image);
  const [projectionId, setProjectionId] = useState(0);
  const [position, setPosition] = useState(0);
  const [layerName, setLayerName] = useState('');
  const [imageBase64, setImageBase64] = useState('');
  const [boundsImage, setBoundsImage] = useState('[[0,0],[0,0]]');
  const [geojsonContent, setGeojsonContent] = useState('');
  const [tilesUrl, setTilesUrl] = useState('');
  const [qgisWms, setQgisWms] = useState({
    url: '',
    parametre: {
      map: '',
      layers: '',
      format: '',
      transparent: '',
    },
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const setters = {
      layer_type: setLayerType,
      projection_id: setProjectionId,
      position: setPosition,
      layer_name: setLayerName,
      tiles_url: setTilesUrl,
      geojson_content: setGeojsonContent,
      bounds_image: setBoundsImage,
    };
    if (setters[name]) {
      setters[name](value);
    }
  };

  const handleQgisWmsChange = (event) => {
    const { name, value } = event.target;
    setQgisWms((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleQgisWmsParameterChange = (event) => {
    const { name, value } = event.target;
    setQgisWms((prev) => ({
      ...prev,
      parametre: {
        ...prev.parametre,
        [name]: value,
      },
    }));
  };

  const handleImageImport = (imageImporter) => {
    setImageBase64(imageImporter.base64);
  };

  const handleSubmit = () => {
    let formulaireCouche = {
      layer_type: parseInt(layerType),
      projection_id: parseInt(projectionId),
      position: parseInt(position),
      layer_name: layerName,
    };

    switch (parseInt(layerType)) {
      case glossaire_type_de_couche.Image:
        formulaireCouche = {
          ...formulaireCouche,
          image_base64: imageBase64,
          bounds_image: IsArrayString(boundsImage, [
            [0, 0],
            [0, 0],
          ]),
          geojson_content: '',
          tiles_url: '',
        };
        break;
      case glossaire_type_de_couche.Tuile:
        formulaireCouche = {
          ...formulaireCouche,
          tiles_url: tilesUrl,
          image_base64: '',
          bounds_image: '',
          geojson_content: '',
        };
        break;
      case glossaire_type_de_couche.GeoJSON:
        formulaireCouche = {
          ...formulaireCouche,
          geojson_content: geojsonContent,
          image_base64: '',
          bounds_image: '',
          tiles_url: '',
        };
        break;
      case glossaire_type_de_couche.QgisWms:
        formulaireCouche = {
          ...formulaireCouche,
          qgis_wms: qgisWms,
          geojson_content: '',
          image_base64: '',
          bounds_image: '',
          tiles_url: '',
        };
        break;
      default:
        formulaireCouche = null;
        break;
    }

    if (formulaireCouche) {
      dispatch(actions.reqAjouterCoucheVue(view_id, formulaireCouche));
    } else {
      console.warn('Type de couche inconnu');
    }
  };

  const renderFormInput = (name, label, pattern) => (
    <div className={[s.col_11, styles.styleNexw].join(' ')}>
      <span className={[styles.stil2].join(' ')}>{label}</span>
      <input
        type="text"
        pattern={pattern}
        className={[s.form_control].join(' ')}
        placeholder={name}
        name={name}
        value={
          preconfigurerVue
            ? {
                layer_type: layerType,
                projection_id: projectionId,
                position: position,
                layer_name: layerName,
                tiles_url: tilesUrl,
                geojson_content: geojsonContent,
                bounds_image: boundsImage,
              }[name]
            : null
        }
        disabled={affichageProfil}
        onChange={handleInputChange}
      />
    </div>
  );

  const renderQgisWmsInput = (name, label, pattern, handler) => (
    <div className={[s.col_11, styles.styleNexw].join(' ')}>
      <span className={[styles.stil2].join(' ')}>{label}</span>
      <input
        type="text"
        pattern={pattern}
        className={[s.form_control].join(' ')}
        placeholder={name}
        name={name}
        value={preconfigurerVue ? qgisWms[name] : null}
        disabled={affichageProfil}
        onChange={handler}
      />
    </div>
  );

  let formulaireCouche;
  switch (parseInt(layerType)) {
    case glossaire_type_de_couche.Image:
      formulaireCouche = (
        <>
          <ImporterImage
            extensionAccepter={'image/png, image/jpeg, image/jpg, .svg'}
            gererImageImporter={handleImageImport}
          />
          <div className={[styles.stillers, s.card].join(' ')}>
            <div className={[styles.stillersT, s.card_header].join(' ')}>
              {checkMot('bounds_image')}
            </div>
            <div className={s.card_body}>
              <div>
                <input
                  defaultChecked
                  type="radio"
                  value={boundsImage}
                  name={boundsImage}
                  onChange={handleInputChange}
                />
                {checkMot("Limites de l'image personalise ")}

                <div
                  style={{
                    display:
                      boundsImage !== '[[0,0],[1080,1920]]' ? 'block' : 'none',
                  }}
                >
                  {' '}
                  {renderFormInput(
                    'bounds_image',
                    checkMot('bounds_image'),
                    glossaire_pattern.array
                  )}
                </div>
              </div>

              <div>
                <input
                  type="radio"
                  value={boundsImage}
                  name={boundsImage}
                  onClick={() => setBoundsImage('[[0,0],[1080,1920]]')}
                />
                {checkMot('1920 x 1080')}
              </div>
            </div>
          </div>
        </>
      );
      break;
    case glossaire_type_de_couche.Tuile:
      formulaireCouche = (
        <>
          {renderFormInput(
            'tiles_url',
            checkMot('tiles_url'),
            glossaire_pattern.text
          )}
        </>
      );
      break;
    case glossaire_type_de_couche.GeoJSON:
      formulaireCouche = (
        <>
          {renderFormInput(
            'geojson_content',
            checkMot('geojson_content'),
            glossaire_pattern.text
          )}
        </>
      );
      break;
    case glossaire_type_de_couche.QgisWms:
      formulaireCouche = (
        <>
          {renderQgisWmsInput(
            'url',
            checkMot('url'),
            glossaire_pattern.text,
            handleQgisWmsChange
          )}
          {renderQgisWmsInput(
            'map',
            checkMot('map'),
            glossaire_pattern.text,
            handleQgisWmsParameterChange
          )}
          {renderQgisWmsInput(
            'layers',
            checkMot('layers'),
            glossaire_pattern.text,
            handleQgisWmsParameterChange
          )}
          {renderQgisWmsInput(
            'format',
            checkMot('format'),
            glossaire_pattern.text,
            handleQgisWmsParameterChange
          )}
          {renderQgisWmsInput(
            'transparent',
            checkMot('transparent'),
            glossaire_pattern.text,
            handleQgisWmsParameterChange
          )}
        </>
      );
      break;
    default:
      formulaireCouche = 'type de couche invalide';
      break;
  }

  return (
    <>
      <div className={[s.row, styles.marge].join(' ')}>
        <div className={[s.col_11, styles.styleNexw].join(' ')}>
          <label className={[styles.stil2].join(' ')}>
            {checkMot('layer_type')}
          </label>
          <select
            value={layerType}
            onChange={handleInputChange}
            name="layer_type"
            className={[s.form_control, s.mb_2].join(' ')}
          >
            <option
              selected={glossaire_type_de_couche.Image}
              value={glossaire_type_de_couche.Image}
            >
              {checkMot('image')}
            </option>
            <option
              selected={glossaire_type_de_couche.Tuile}
              value={glossaire_type_de_couche.Tuile}
            >
              {checkMot('tuile')}
            </option>
            <option
              selected={glossaire_type_de_couche.GeoJSON}
              value={glossaire_type_de_couche.GeoJSON}
            >
              {checkMot('geojson')}
            </option>
            <option
              selected={glossaire_type_de_couche.QgisWms}
              value={glossaire_type_de_couche.QgisWms}
            >
              {checkMot('qgis_wms')}
            </option>
          </select>
        </div>
        {renderFormInput(
          'projection_id',
          checkMot('projection_id'),
          glossaire_pattern.integer
        )}
        {renderFormInput(
          'position',
          checkMot('position'),
          glossaire_pattern.integer
        )}
        {renderFormInput(
          'layer_name',
          checkMot('layer_name'),
          glossaire_pattern.text
        )}
        {formulaireCouche}
      </div>
      <div className={[s.text_left, styles.styleNexw].join(' ')}>
        <AttenteRequete
          request_type={requestType.ajouter_une_couche_de_vue}
          str={checkMot('creation_en_cour')}
        >
          <Bouton cliquer={handleSubmit}>{checkMot('enregistrer')}</Bouton>
        </AttenteRequete>
      </div>
    </>
  );
};

export default AjouterCouche;
